import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from "rxjs";
import { ServiceAttentionSchedule } from "./api-interfaces/api-interface-attention-schedule";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIAttentionSchedule{
    ApiURL: string = "";
    constructor(private http: HttpClient,public helperService: HelperService) {
        this.ApiURL = environment.AttentionSchedule + 'ServiceAttentionSchedule/';
    }


    public get(id: string): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };

        if (id !== null && id !== undefined) {
            return this.http.get(this.ApiURL + encodeURIComponent(id),requestOptions);
       } else {
      
       return this.http.get(this.ApiURL,requestOptions );
           
        }
    }


    public getWebViewMAxAndMinimumHours(countryid,cityid,brandid): Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let url = this.ApiURL + "TimeRangeAndLenght/"+ countryid+"/"+cityid+"/"+brandid; 
        return this.http.get(url,requestOptions);    
    }

    public getDealerBlockedSchedule(workshopId: string | number): Observable<any>{
        //The api endpoints used here uses "DealerBlockedServices/" but this one uses "ApiServiceAttentionSchedule"
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let url = this.ApiURL + "byWorkshop/"; 
        return this.http.get(url+workshopId,requestOptions);    
    }


    public post(attencion:ServiceAttentionSchedule): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };

        return this.http.post<any>(this.ApiURL, attencion,requestOptions)

    }

    public put(attention:ServiceAttentionSchedule): Observable<any> {
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.put<any>(this.ApiURL, attention,requestOptions)


    }
    public delete(id: number):  Observable<any>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        let apiURL = `${this.ApiURL}${id}`;
        return this.http.delete(apiURL,requestOptions)
    }

    

}